/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartAreaH = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m22.11 2-5.264 6.432 5.724 5.723-6.44 4.292L19.174 22H2V2zm-4.22 2H4v16h10.826l-5.13-5.985zm-2.316 5.988-3.269 3.996 2.514 2.932 4.611-3.072z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartAreaH as ChartAreaH };
